import React, { Component } from 'react';
import classnames from 'classnames';

import './CreateEntityModal.css';

// Entity type forms
import CreateEntityForm_0 from './TypeForms/Type_0/CreateEntityForm_0';
import CreateEntityForm_1 from './TypeForms/Type_1/CreateEntityForm_1';
import CreateEntityForm_2 from './TypeForms/Type_2/CreateEntityForm_2';
import CreateEntityForm_3 from './TypeForms/Type_3/CreateEntityForm_3';

// API Functions
import { createEntity_0, createEntity_1, createEntity_2, createEntity_3 } from './CreateEntityModalAPI';

class CreateEntityModal extends Component {

  static defaultProps = {
    quitEntityModal : () => {
      
    },
    selectedEntityType : null,
  }

  SYNONYM_START_STR = "{:{";
  SYNONYM_END_STR = "}:}";
  SYNONYM_DIVIDER_STR = "\t";

  handleQuitEntityModal = (e) => {
    e.stopPropagation();
    this.props.quitEntityModal();
  }

  handleCreateEntity_0 = (entityName, entityLanguage, entitySynonyms) => {
    if (entitySynonyms.length <= 0) {
      if (window.confirm("Synonym 엔티티가 존재하지 않습니다. 그래도 생성 하시겠습니까?")) {
        this.createEntity_0Wrapper(entityName, entityLanguage, entitySynonyms);
      }
    } else {
      this.createEntity_0Wrapper(entityName, entityLanguage, entitySynonyms);
    }
  }
  createEntity_0Wrapper = (name, language, entitySynonyms) => {
    // parse to str
    const entitySynonyms_toParamData = entitySynonyms.map( (entitySynonym, i) => {
      let entity_string = "";
      entity_string += entitySynonym.name;
      if (entitySynonym.synonyms.length > 0) {
        const { synonyms } = entitySynonym;
        entity_string += this.SYNONYM_START_STR;

        synonyms.map( (synonym, i) => {
          entity_string += synonym;
          if (synonyms.length !== i+1) { entity_string += this.SYNONYM_DIVIDER_STR; } // divider string
        })

        entity_string += this.SYNONYM_END_STR;
      }
      return entity_string;
    })
    

    createEntity_0(this.createEntity_0_callBack, this.createEntity_0_errorCallBack, 
      this.props.topicId, 
      0,
      name, 
      language, 
      entitySynonyms_toParamData,
      entitySynonyms);
  }
  createEntity_0_callBack = (response, entity) => {
    const { data } = response;
    const { statusCode } = data;

    switch(statusCode) {
      case 200:
      const { property } = data;
      const { updateID } = property;

      this.props.addEntityToType(0, updateID, entity.entityName, entity.entityLanguage, entity.entityValue);
      break;
      
      case 403:
      alert("중복된 엔티티 이름입니다.");
      break;

      case 500:
      alert("서버에서 에러가 발생하였습니다.");
      break;

      default:
      alert("에러가 발생하였습니다.");
      break;

    }
  }
  createEntity_0_errorCallBack = (error) => {
    alert("에러가 발생했습니다.");
  }

  handleCreateEntity_1 = (entityName, entityLanguage, regex_value) => {
    this.createEntity_1Wrapper(entityName, entityLanguage, regex_value);
  }
  createEntity_1Wrapper = (name, language, regex_value) => {
    createEntity_1(this.createEntity_1_callBack, this.createEntity_1_errorCallBack, 
      this.props.topicId, 
      1,
      name, 
      language, 
      regex_value);
  }
  createEntity_1_callBack = (response, entity) => {
    const { data } = response;
    const { statusCode } = data;

    switch(statusCode) {
      case 200:
      const { property } = data;
      const { updateID } = property;

      this.props.addEntityToType(1, updateID, entity.entityName, entity.entityLanguage, entity.entityValue);
      break;
      
      case 403:
      alert("중복된 엔티티 이름입니다.");
      break;

      case 500:
      alert("서버에서 에러가 발생하였습니다.");
      break;

      default:
      alert("에러가 발생하였습니다.");
      break;

    }
  }
  createEntity_1_errorCallBack = (error) => {
    alert("에러가 발생했습니다.");
    
  }

  handleCreateEntity_2 = (entityName, entityLanguage, regex_value, entityFunction) => {
    this.createEntity_2Wrapper(entityName, entityLanguage, regex_value,entityFunction);
  }
  createEntity_2Wrapper = (name, language, regex_value, entityFunction) => {
    createEntity_2(this.createEntity_2_callBack, this.createEntity_2_errorCallBack, 
      this.props.topicId, 
      2,
      name, 
      language, 
      regex_value,
      entityFunction,);
  }
  createEntity_2_callBack = (response, entity) => {
    const { data } = response;
    const { statusCode } = data;

    switch(statusCode) {
      case 200:
      const { property } = data;
      const { updateID } = property;

      this.props.addEntityToType(2, updateID, entity.entityName, entity.entityLanguage, entity.entityValue, entity.function);
      break;
      
      case 403:
      alert("중복된 엔티티 이름입니다.");
      break;

      case 500:
      alert("서버에서 에러가 발생하였습니다.");
      break;

      default:
      alert("에러가 발생하였습니다.");
      break;

    }
  }
  createEntity_2_errorCallBack = (error) => {
    alert("에러가 발생했습니다.");
    
  }

  handleCreateEntity_3 = (entityName, entityLanguage, memberEntities) => {
    this.createEntity_3Wrapper(entityName, entityLanguage, memberEntities);
  }
  createEntity_3Wrapper = (name, language, memberEntities) => {
    createEntity_3(this.createEntity_3_callBack, this.createEntity_3_errorCallBack, 
      this.props.topicId, 
      3,
      name, 
      language, 
      memberEntities);
  }
  createEntity_3_callBack = (response, entity) => {
    
    
    const { data } = response;
    const { statusCode } = data;

    switch(statusCode) {
      case 200:
      const { property } = data;
      const { updateID } = property;

      this.props.addEntityToType(3, updateID, entity.entityName, entity.entityLanguage);
      break;
      
      case 403:
      alert("중복된 엔티티 이름입니다.");
      break;

      case 500:
      alert("서버에서 에러가 발생하였습니다.");
      break;

      default:
      alert("에러가 발생하였습니다.");
      break;

    }
  }
  createEntity_3_errorCallBack = (error) => {
    alert("에러가 발생했습니다.");
    
  }

  render() { 
    
    const formRender = () => {
      if (this.props.isShow) {
        if (!this.props.selectedEntityType && typeof this.props.selectedEntityType !== 'number') {
          return (
            <p> 선택된 엔티티 타입이 없습니다. </p>
          )
        }
        
        switch(this.props.selectedEntityType) {
          case 0:
          return (
            <CreateEntityForm_0
              createEntity={this.handleCreateEntity_0} />
          )
  
          case 1: 
          return (
            <CreateEntityForm_1
              createEntity={this.handleCreateEntity_1} />
          )
  
          case 2:
          return (
            <CreateEntityForm_2
              createEntity={this.handleCreateEntity_2} />
          )
  
          case 3:
          return (
            <CreateEntityForm_3
              topicId={this.props.topicId}
              createEntity={this.handleCreateEntity_3} />
          )
  
          default:
  
        }
      } 
    }

    const whiteSpace_classNames = classnames({
      "white-space" : this.props.isShow,
      "second-modal-white-space" : this.props.isShow,
      "create-modal" : true,
      "show" : (this.props.isShow ? true : false),
      "hide" : (this.props.isShow ? false : true),
    })

    return (
      <React.Fragment>
        <div
          onClick={this.handleQuitEntityModal} 
          className={whiteSpace_classNames}>
        </div>
        <div id="CreateEntityModal"
          onClick={e => {e.stopPropagation()}}
          className={ this.props.isShow ? "show" : "hide" }>
          <div className="header">
            <p className="title"> 엔티티 생성 </p>
          </div>
          <div className="body">
            {formRender()}
          </div>
          {/* <div className="bottom">

          </div> */}
        </div>
      </React.Fragment>
      
    );
  }
}
 
export default CreateEntityModal;